export const funcionesCustom = {
  fnSuma: (...nums) => nums.reduce((acc, val) => acc + (parseFloat(val) || 0), 0),

  fnValoresUnicos: (...args) => [...new Set(args.flat())].join(', '),
}
